export default "__VITE_ASSET__90747dea__"